module.exports = __webpack_public_path__ + "assets/img/8d858fa2f717b288975756f8ef9a15de.png";